import { useCallback } from 'react';
import { useLocation, useMatch, useNavigate } from 'react-router-dom';

import { Routes, vehicleCatalogMakePath } from '../../../routes/routes';

/**
 * The open make lives in the path (`/vehicle-catalog/:makeId`, AUT-437) so a
 * drawer is linkable; opening / closing keeps the list's query string
 * (filters) intact.
 */
export const useMakeRoute = (): {
  makeId: string | null;
  openMake: (makeId: string) => void;
  closeMake: () => void;
} => {
  const match = useMatch(Routes.App.VehicleCatalogMake);
  const navigate = useNavigate();
  const { search } = useLocation();

  const openMake = useCallback(
    (makeId: string) => navigate({ pathname: vehicleCatalogMakePath(makeId), search }),
    [navigate, search],
  );
  const closeMake = useCallback(
    () => navigate({ pathname: Routes.App.VehicleCatalog, search }),
    [navigate, search],
  );

  return { makeId: match?.params.makeId ?? null, openMake, closeMake };
};
